<template>
  <cTable :fields="fields" :footer="footer" :config="config" ref="table">
  </cTable>
</template>
<script>
import numFun from "@/utils/numFun";
import cTable from "@/base/common/index";

export default {
  props: {
    row: Array,
  },
  components: {
    cTable,
  },
  mounted() {
    this.$refs.table.list = this.row;
  },
  data() {
    return {
      config: {
        resize: false,
        slot: "div",
        height: "200",
        showFooter: true,
        footerCellClassName: "col-red",
      },
      footer: {
        show: () => false,
      },
      fields: [
        {
          name: () => this.$t("billingCurrency"),
          key: "currency",
          minWidth: 130,
        },
        {
          name: () => this.$t("expType"),
          key: "charge_type",
          minWidth: 130,
        },
        {
          name: () => this.$t("billing_price"),
          key: "charge_price",
          minWidth: 130,
        },
        {
          name: () => this.$t("quantity1"),
          key: "charge_value",
          minWidth: 130,
        },
        {
          name: () => this.$t("Billing") + this.$t('reChAmount'),
          key: "charge_amount",
          minWidth: 130,
        },
      ],
    };
  },
};
</script>
